import React from "react";
import ButtonComponent from "./button";

const AudioModal = ({ open, setOpen }) => {
  if (!open.open) {
    return false;
  }

  return (
    <div
      id="extralarge-modal"
      tabIndex="-1"
      className="bg-gray-800 w-full w-max-full h-100 p-4 justify-content-center m-auto fixed top-0 left-0 right-0 z-50 md:inset-0"
      style={{}}
    >
      <div className="relative align-content-center" style={{height: "-webkit-fill-available"}}>
        <div className="text-white text-sm-xlm-auto w-auto">
          <p className=" text-3xl font-semibold m-auto w-[fit-content]">
            Do you want to turn ON the volume?
          </p>
          <div className="w-[fit-content] m-auto mt-3 d-flex">
            <button
              type="button"
              className="text-xl w-full text-center text-black
                   shadow-lg 
                   font-medium rounded-lg text-sm px-2 px-sm-2 px-md-4 
                   px-lg-4 py-1 py-sm-1 py-md-2 py-lg-2 text-center mx-2 my-1"
              onClick={() => {
                setOpen({ open: false, allow: true });
              }}
              style={{ backgroundColor: "#F8B731" }}
            >
              Yes
            </button>
            <button
              type="button"
              className="text-xl w-full text-center text-black
                   shadow-lg 
                   font-medium rounded-lg text-sm px-2 px-sm-2 px-md-4 
                   px-lg-4 py-1 py-sm-1 py-md-2 py-lg-2 text-center mx-2 my-1"
              onClick={() => {
                setOpen({ open: false, allow: false });
              }}
              style={{ backgroundColor: "#F8B731" }}
            >
              No
            </button>
            
          </div>
          
        </div>
      </div>
    </div>
  );
};
export default AudioModal;
